export const gitInfo = { commitHash: "c6796cf", version: "v3.0.0-2-gc6796cf" };
